export default "__VITE_ASSET__2e29d3f6__"